// extracted by mini-css-extract-plugin
module.exports = {"sokeresultat":"dhsg7EaGT-sokeresultat","beskrivelse":"dhsgmTncY-beskrivelse","antall":"dhsg3ZowZ-antall","henter":"dhsg3E_Eb-henter"};